import { SignJWT } from "jose";
import { Buffer } from "buffer";

export interface Dashboard {
  id: string;
  name: string;
  description: string;
  resourceId: number;
  category: string;
  params?: Record<string, any>;
}

const DASHBOARD_CONFIG: Dashboard[] = [
  {
    id: "1",
    name: "Error Logger Dashboard",
    description: "Dashboard for monitoring error logs and trends.",
    resourceId: 96,
    category: "Errors",
    params: {},
  },
  {
    id: "2",
    name: "Leads Dashboard",
    description: "Dashboard for tracking lead performance.",
    resourceId: 97,
    category: "Leads",
    params: {},
  },
  {
    id: "3",
    name: "Policy Dashboard",
    description: "Dashboard for tracking policies performance.",
    resourceId: 98,
    category: "Policies",
    params: {},
  },
];

// Metabase configuration
const METABASE_SITE_URL = process.env.REACT_APP_METABASE_DASHBOARD_URL;
const METABASE_SECRET_KEY = process.env.REACT_APP_METABASE_SECRET_KEY;

// Generate Metabase signed URL
export const generateMetabaseUrl = async (
  resourceType: string,
  resourceId: number,
  params: Record<string, any> = {},
  useNightTheme = false
) => {
  try {
    const payload = {
      resource:
        resourceType === "dashboard"
          ? { dashboard: resourceId }
          : { question: resourceId },
      params: {},
      exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
    };
    if (!METABASE_SECRET_KEY) {
      throw new Error(
        "METABASE_SECRET_KEY is not defined in environment variables!"
      );
    }

    // Convert secret key to Uint8Array for jose
    const secret = Buffer.from(METABASE_SECRET_KEY, "utf-8");

    // Create JWT using jose
    const token = await new SignJWT(payload)
      .setProtectedHeader({ alg: "HS256" })
      .setExpirationTime("60m")
      .sign(secret);

    const endpoint = resourceType === "dashboard" ? "dashboard" : "question";
    const hash = useNightTheme
      ? "#theme=night&bordered=true&titled=true"
      : "#bordered=true&titled=true";
    const query = new URLSearchParams(params).toString();

    return `${METABASE_SITE_URL}/embed/${endpoint}/${token}${
      query ? `?${query}` : ""
    }${hash}`;
  } catch (error) {
    console.error("Error generating Metabase URL:", error);
    return "null";
  }
};

export { METABASE_SITE_URL, DASHBOARD_CONFIG };
